// source: acompanha/desktop_releases/v1/desktop_releases.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js');
goog.object.extend(proto, acompanha_common_v1_common_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest', null, global);
goog.exportSymbol('proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse', null, global);
goog.exportSymbol('proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest', null, global);
goog.exportSymbol('proto.acompanha.desktop_releases.v1.DesktopRelease', null, global);
goog.exportSymbol('proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest', null, global);
goog.exportSymbol('proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse', null, global);
goog.exportSymbol('proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest', null, global);
goog.exportSymbol('proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse', null, global);
goog.exportSymbol('proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest', null, global);
goog.exportSymbol('proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse', null, global);
goog.exportSymbol('proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest', null, global);
goog.exportSymbol('proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.desktop_releases.v1.DesktopRelease = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.desktop_releases.v1.DesktopRelease, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.desktop_releases.v1.DesktopRelease.displayName = 'proto.acompanha.desktop_releases.v1.DesktopRelease';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest.displayName = 'proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse.displayName = 'proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest.displayName = 'proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse.displayName = 'proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest.displayName = 'proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse.displayName = 'proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.displayName = 'proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse.displayName = 'proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.displayName = 'proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse.displayName = 'proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest.displayName = 'proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.desktop_releases.v1.DesktopRelease.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.desktop_releases.v1.DesktopRelease} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
version: jspb.Message.getFieldWithDefault(msg, 2, ""),
title: jspb.Message.getFieldWithDefault(msg, 3, ""),
changelog: jspb.Message.getFieldWithDefault(msg, 4, ""),
downloadWindows: jspb.Message.getFieldWithDefault(msg, 5, ""),
downloadMac: jspb.Message.getFieldWithDefault(msg, 6, ""),
downloadLinux: jspb.Message.getFieldWithDefault(msg, 7, ""),
publishedAt: (f = msg.getPublishedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
active: jspb.Message.getBooleanFieldWithDefault(msg, 11, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.desktop_releases.v1.DesktopRelease}
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.desktop_releases.v1.DesktopRelease;
  return proto.acompanha.desktop_releases.v1.DesktopRelease.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.desktop_releases.v1.DesktopRelease} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.desktop_releases.v1.DesktopRelease}
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setChangelog(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDownloadWindows(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDownloadMac(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDownloadLinux(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPublishedAt(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.desktop_releases.v1.DesktopRelease.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.desktop_releases.v1.DesktopRelease} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getChangelog();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDownloadWindows();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDownloadMac();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDownloadLinux();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPublishedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.desktop_releases.v1.DesktopRelease} returns this
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string version = 2;
 * @return {string}
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.desktop_releases.v1.DesktopRelease} returns this
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.desktop_releases.v1.DesktopRelease} returns this
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string changelog = 4;
 * @return {string}
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.getChangelog = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.desktop_releases.v1.DesktopRelease} returns this
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.setChangelog = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string download_windows = 5;
 * @return {string}
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.getDownloadWindows = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.desktop_releases.v1.DesktopRelease} returns this
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.setDownloadWindows = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string download_mac = 6;
 * @return {string}
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.getDownloadMac = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.desktop_releases.v1.DesktopRelease} returns this
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.setDownloadMac = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string download_linux = 7;
 * @return {string}
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.getDownloadLinux = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.desktop_releases.v1.DesktopRelease} returns this
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.setDownloadLinux = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp published_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.getPublishedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.desktop_releases.v1.DesktopRelease} returns this
*/
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.setPublishedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.desktop_releases.v1.DesktopRelease} returns this
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.clearPublishedAt = function() {
  return this.setPublishedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.hasPublishedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.desktop_releases.v1.DesktopRelease} returns this
*/
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.desktop_releases.v1.DesktopRelease} returns this
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.desktop_releases.v1.DesktopRelease} returns this
*/
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.desktop_releases.v1.DesktopRelease} returns this
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional bool active = 11;
 * @return {boolean}
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.desktop_releases.v1.DesktopRelease} returns this
 */
proto.acompanha.desktop_releases.v1.DesktopRelease.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest}
 */
proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest;
  return proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest}
 */
proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.ListDesktopReleasesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.acompanha.desktop_releases.v1.DesktopRelease.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse}
 */
proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse;
  return proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse}
 */
proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.desktop_releases.v1.DesktopRelease;
      reader.readMessage(value,proto.acompanha.desktop_releases.v1.DesktopRelease.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.desktop_releases.v1.DesktopRelease.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DesktopRelease data = 1;
 * @return {!Array<!proto.acompanha.desktop_releases.v1.DesktopRelease>}
 */
proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.acompanha.desktop_releases.v1.DesktopRelease>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.desktop_releases.v1.DesktopRelease, 1));
};


/**
 * @param {!Array<!proto.acompanha.desktop_releases.v1.DesktopRelease>} value
 * @return {!proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse} returns this
*/
proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.desktop_releases.v1.DesktopRelease=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.desktop_releases.v1.DesktopRelease}
 */
proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.desktop_releases.v1.DesktopRelease, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse} returns this
 */
proto.acompanha.desktop_releases.v1.ListDesktopReleasesResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest}
 */
proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest;
  return proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest}
 */
proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.desktop_releases.v1.DesktopRelease.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse}
 */
proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse;
  return proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse}
 */
proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.desktop_releases.v1.DesktopRelease;
      reader.readMessage(value,proto.acompanha.desktop_releases.v1.DesktopRelease.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.desktop_releases.v1.DesktopRelease.serializeBinaryToWriter
    );
  }
};


/**
 * optional DesktopRelease data = 1;
 * @return {?proto.acompanha.desktop_releases.v1.DesktopRelease}
 */
proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.desktop_releases.v1.DesktopRelease} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.desktop_releases.v1.DesktopRelease, 1));
};


/**
 * @param {?proto.acompanha.desktop_releases.v1.DesktopRelease|undefined} value
 * @return {!proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse} returns this
*/
proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse} returns this
 */
proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.desktop_releases.v1.GetLatestDesktopReleaseResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest}
 */
proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest;
  return proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest}
 */
proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest} returns this
 */
proto.acompanha.desktop_releases.v1.GetDesktopReleaseRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.desktop_releases.v1.DesktopRelease.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse}
 */
proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse;
  return proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse}
 */
proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.desktop_releases.v1.DesktopRelease;
      reader.readMessage(value,proto.acompanha.desktop_releases.v1.DesktopRelease.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.desktop_releases.v1.DesktopRelease.serializeBinaryToWriter
    );
  }
};


/**
 * optional DesktopRelease data = 1;
 * @return {?proto.acompanha.desktop_releases.v1.DesktopRelease}
 */
proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.desktop_releases.v1.DesktopRelease} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.desktop_releases.v1.DesktopRelease, 1));
};


/**
 * @param {?proto.acompanha.desktop_releases.v1.DesktopRelease|undefined} value
 * @return {!proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse} returns this
*/
proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse} returns this
 */
proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.desktop_releases.v1.GetDesktopReleaseResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
version: jspb.Message.getFieldWithDefault(msg, 1, ""),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
changelog: jspb.Message.getFieldWithDefault(msg, 3, ""),
downloadWindows: jspb.Message.getFieldWithDefault(msg, 4, ""),
downloadMac: jspb.Message.getFieldWithDefault(msg, 5, ""),
downloadLinux: jspb.Message.getFieldWithDefault(msg, 6, ""),
active: (f = jspb.Message.getBooleanField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest}
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest;
  return proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest}
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setChangelog(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDownloadWindows(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDownloadMac(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDownloadLinux(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getChangelog();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDownloadWindows();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDownloadMac();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDownloadLinux();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional string version = 1;
 * @return {string}
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest} returns this
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest} returns this
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string changelog = 3;
 * @return {string}
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.prototype.getChangelog = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest} returns this
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.prototype.setChangelog = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string download_windows = 4;
 * @return {string}
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.prototype.getDownloadWindows = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest} returns this
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.prototype.setDownloadWindows = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string download_mac = 5;
 * @return {string}
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.prototype.getDownloadMac = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest} returns this
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.prototype.setDownloadMac = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string download_linux = 6;
 * @return {string}
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.prototype.getDownloadLinux = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest} returns this
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.prototype.setDownloadLinux = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool active = 7;
 * @return {boolean}
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest} returns this
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.prototype.setActive = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest} returns this
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.prototype.clearActive = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseRequest.prototype.hasActive = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.desktop_releases.v1.DesktopRelease.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse}
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse;
  return proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse}
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.desktop_releases.v1.DesktopRelease;
      reader.readMessage(value,proto.acompanha.desktop_releases.v1.DesktopRelease.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.desktop_releases.v1.DesktopRelease.serializeBinaryToWriter
    );
  }
};


/**
 * optional DesktopRelease data = 1;
 * @return {?proto.acompanha.desktop_releases.v1.DesktopRelease}
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.desktop_releases.v1.DesktopRelease} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.desktop_releases.v1.DesktopRelease, 1));
};


/**
 * @param {?proto.acompanha.desktop_releases.v1.DesktopRelease|undefined} value
 * @return {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse} returns this
*/
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse} returns this
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.desktop_releases.v1.CreateDesktopReleaseResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
version: jspb.Message.getFieldWithDefault(msg, 2, ""),
title: jspb.Message.getFieldWithDefault(msg, 3, ""),
changelog: jspb.Message.getFieldWithDefault(msg, 4, ""),
downloadWindows: jspb.Message.getFieldWithDefault(msg, 5, ""),
downloadMac: jspb.Message.getFieldWithDefault(msg, 6, ""),
downloadLinux: jspb.Message.getFieldWithDefault(msg, 7, ""),
active: (f = jspb.Message.getBooleanField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest}
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest;
  return proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest}
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setChangelog(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDownloadWindows(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDownloadMac(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDownloadLinux(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getChangelog();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDownloadWindows();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDownloadMac();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDownloadLinux();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest} returns this
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string version = 2;
 * @return {string}
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest} returns this
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest} returns this
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string changelog = 4;
 * @return {string}
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.prototype.getChangelog = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest} returns this
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.prototype.setChangelog = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string download_windows = 5;
 * @return {string}
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.prototype.getDownloadWindows = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest} returns this
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.prototype.setDownloadWindows = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string download_mac = 6;
 * @return {string}
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.prototype.getDownloadMac = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest} returns this
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.prototype.setDownloadMac = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string download_linux = 7;
 * @return {string}
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.prototype.getDownloadLinux = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest} returns this
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.prototype.setDownloadLinux = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool active = 8;
 * @return {boolean}
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest} returns this
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.prototype.setActive = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest} returns this
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.prototype.clearActive = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseRequest.prototype.hasActive = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.desktop_releases.v1.DesktopRelease.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse}
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse;
  return proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse}
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.desktop_releases.v1.DesktopRelease;
      reader.readMessage(value,proto.acompanha.desktop_releases.v1.DesktopRelease.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.desktop_releases.v1.DesktopRelease.serializeBinaryToWriter
    );
  }
};


/**
 * optional DesktopRelease data = 1;
 * @return {?proto.acompanha.desktop_releases.v1.DesktopRelease}
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.desktop_releases.v1.DesktopRelease} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.desktop_releases.v1.DesktopRelease, 1));
};


/**
 * @param {?proto.acompanha.desktop_releases.v1.DesktopRelease|undefined} value
 * @return {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse} returns this
*/
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse} returns this
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.desktop_releases.v1.UpdateDesktopReleaseResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest}
 */
proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest;
  return proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest}
 */
proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest} returns this
 */
proto.acompanha.desktop_releases.v1.DeleteDesktopReleaseRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.acompanha.desktop_releases.v1);
